import axios from 'axios';

const STORAGE_KEY = 'wownautic_payment_diag_session';
const SESSION_HEADER = 'X-Payment-Diag-Session';

export const getPaymentTraceSessionId = () => {
  try {
    let id = sessionStorage.getItem(STORAGE_KEY);
    if (!id) {
      id =
        typeof crypto !== 'undefined' && crypto.randomUUID
          ? crypto.randomUUID()
          : `pt-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
      sessionStorage.setItem(STORAGE_KEY, id);
    }
    return id;
  } catch {
    return `pt-${Date.now()}`;
  }
};

export const resetPaymentTraceSession = () => {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
};

export const paymentTraceHeaders = () => ({
  [SESSION_HEADER]: getPaymentTraceSessionId(),
});

/**
 * Fire-and-forget client-side payment step beacon (dev/prod diagnostics).
 */
export const paymentTrace = (step, detail = {}, extra = {}) => {
  const API_URL = process.env.REACT_APP_BACKEND_URL || '';
  const session_id = getPaymentTraceSessionId();
  const payload = {
    step,
    session_id,
    source: 'frontend',
    booking_id: extra.booking_id ?? detail.booking_id ?? null,
    payment_intent_id: extra.payment_intent_id ?? detail.payment_intent_id ?? null,
    detail: {
      ...detail,
      url: typeof window !== 'undefined' ? window.location.href : null,
      path: typeof window !== 'undefined' ? window.location.pathname : null,
      search: typeof window !== 'undefined' ? window.location.search : null,
    },
  };

  console.info('[PAYMENT_DIAG]', step, payload.detail);

  // Empty REACT_APP_BACKEND_URL means same-origin relative /api (prod & most deploys).
  axios
    .post(`${API_URL}/api/diagnostics/payment-trace`, payload, {
      headers: paymentTraceHeaders(),
    })
    .catch(() => {
      /* non-blocking */
    });
};
